export const SERVER_STREAM_ENDED = 'SERVER_HTTP_RESPONSE_ENDED' as const;
